export const createTeamMemberFormStyle = {
	form: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: '16px',
		marginTop: '40px',
		paddingBottom: '16px',
	},

	formRow: {
		display: 'flex',
		gap: '16px',
		alignItems: 'flex-end',
		justifyContent: 'space-between',

		'&>.MuiBox-root': {
			width: '265px',
		},
		'.MuiButtonBase-root': {
			fontWeight: 700,
		},
	},

	passwordIcon: {
		'& svg path': {
			fill: 'var(--neutral-200)',
		},

		'& .Mui-error svg path': {
			fill: 'var(--error-500)',
		},
	},
};
